import React, { useState, useEffect } from 'react';
import { Col, Text, CMSLayout, Row, Input, Button } from 'components';
import { IScreen } from 'type';
import Store from 'store';
import { useNavFunc } from 'navigation';
import { COLOR, SCREEN } from 'const';
import { VarHelper } from 'helpers';

// USD trước, VND sau; trong mỗi loại xếp theo mệnh giá tăng dần
const sortQuyUoc = (data: any[]) => {
  return [...data].sort((a, b) => {
    const currencyOrder = (c: string) => (c === 'USD' ? 0 : 1);
    const orderA = currencyOrder(a.currency || '');
    const orderB = currencyOrder(b.currency || '');
    if (orderA !== orderB) return orderA - orderB;
    const valA = Number(a.displayValue) || 0;
    const valB = Number(b.displayValue) || 0;
    return valA - valB;
  });
};

const Admin: IScreen = () => {
  const { navigate } = useNavFunc();
  const [list, setList] = useState<any[]>([]);
  const [originalList, setOriginalList] = useState<any[]>([]);
  const [saving, setSaving] = useState(false);

  const getData = async () => {
    const res = await Store.Api.QuyUoc.list({});
    if (res.data.success) {
      const data = sortQuyUoc(res.data.data);
      setList(data);
      setOriginalList(data);
    }
  };

  const isChanged = (val: any, field: 'price' | 'priceYearPair' | 'priceYearPairSpecial') => {
    const orig = originalList.find((o: any) => o.id === val.id);
    if (!orig) return false;
    const cur = val[field] ?? null;
    const prev = orig[field] ?? null;
    return cur !== prev;
  };

  useEffect(() => {
    getData();
  }, []);

  const updateRow = (id: string, field: 'price' | 'priceYearPair' | 'priceYearPairSpecial', value: string) => {
    const cleaned = value.replace(/,/g, '');
    const num = cleaned === '' ? null : Number(cleaned);
    if (cleaned !== '' && isNaN(num)) return;
    setList(prev => prev.map(r => r.id !== id ? r : { ...r, [field]: num }));
  };

  const saveAll = async () => {
    setSaving(true);
    for (const val of list) {
      const res = await Store.Api.QuyUoc.upsert({
        id: val.id,
        price: val.price ?? null,
        priceYearPair: val.priceYearPair ?? null,
        priceYearPairSpecial: val.priceYearPairSpecial ?? null,
      });
      if (!res.data?.success) {
        setSaving(false);
        alert(res.data?.error || 'Lưu thất bại');
        return;
      }
    }
    setSaving(false);
    getData();
  };

  return (
    <CMSLayout requireAuthen>
      <Row m1 p1 backgroundColor={COLOR.MAIN} round1>
        <Col flex1>
          <Text bold colorWhite>Viết tắt</Text>
        </Col>
        <Col flex1>
          <Text bold colorWhite>Mệnh giá</Text>
        </Col>
        <Col flex1 mr1>
          <Text bold colorWhite>Giá bán</Text>
        </Col>
        <Col flex1 mr1>
          <Text bold numberOfLines={1} colorWhite>Giá cặp đôi</Text>
        </Col>
        <Col flex1>
          <Text bold numberOfLines={1} colorWhite>Giá cặp đôi đặc biệt</Text>
        </Col>
      </Row>
      {list.map((val, i) => (
        <Col m1 p1 backgroundColor={i % 2 === 0 ? 'rgba(255,255,255,0.8)' : '#ddd'} round1 key={val.id}>
          <Row mb0 alignItems="center">
            <Col flex1>
              <Text>{val.short}</Text>
            </Col>
            <Col flex1>
              <Text>{VarHelper.formatMoney(val.displayValue)}</Text>
            </Col>
            <Col flex1 mr1>
              <Input
                borderRadius={6}
                height={32}
                inputProps={{ keyboardType: 'numeric' }}
                value={VarHelper.formatMoney(val.price ?? 0)}
                onChange={(v) => updateRow(val.id, 'price', v)}
                style={isChanged(val, 'price') ? { borderColor: 'red', borderWidth: 2 } : undefined}
              />
            </Col>
            <Col flex1 mr1>
              <Input
                borderRadius={6}
                height={32}
                inputProps={{ keyboardType: 'numeric' }}
                value={VarHelper.formatMoney(val.priceYearPair ?? 0)}
                onChange={(v) => updateRow(val.id, 'priceYearPair', v)}
                style={isChanged(val, 'priceYearPair') ? { borderColor: 'red', borderWidth: 2 } : undefined}
              />
            </Col>
            <Col flex1>
              <Input
                borderRadius={6}
                height={32}
                inputProps={{ keyboardType: 'numeric' }}
                value={VarHelper.formatMoney(val.priceYearPairSpecial ?? 0)}
                onChange={(v) => updateRow(val.id, 'priceYearPairSpecial', v)}
                style={isChanged(val, 'priceYearPairSpecial') ? { borderColor: 'red', borderWidth: 2 } : undefined}
              />
            </Col>
          </Row>
        </Col>
      ))}
      <Row m1 mt1 alignItems="center">
        <Button
          text={saving ? 'Đang lưu...' : 'Lưu thay đổi'}
          onPress={() => {
            if (confirm('Bạn có chắc muốn lưu thay đổi?')) saveAll();
          }}
          disabled={saving || list.length === 0}
        />
        <Button
          text="Hủy"
          onPress={() => {
            if (confirm('Bạn có chắc muốn hủy? Mọi thay đổi chưa lưu sẽ bị mất.')) getData();
          }}
          outline
          ml1
        />
      </Row>
    </CMSLayout>
  )
};

Admin.routeInfo = {
  title: 'Quy Ước tiền',
  path: '/admin/quy-uoc',
};

export default Admin;
